module.exports = __webpack_public_path__ + "static/media/Error-404.460532d9.gif";